// Utility functions for tree node detection and traversal

import { NodeTypeScheme } from '../types/base';

/**
 * Recursively checks if a target node (by ID or ref) is a child of the given container items
 * @param targetId - The ID or ref of the target node to find
 * @param items - Array of items to search through
 * @param visited - Set to track visited nodes and prevent infinite loops
 * @returns boolean indicating if the target node is found as a child
 */
export const isNodeChild = (
  targetId: string, 
  items?: NodeTypeScheme[] | any[], 
  visited = new Set<string>()
): boolean => {
  if (!targetId || !items || !Array.isArray(items)) return false;
  
  for (const item of items) {
    // Prevent infinite loops in case of circular references
    const itemId = item.id || item.settings?.ref;
    if (!itemId || visited.has(itemId)) continue;
    
    visited.add(itemId);
    
    // Check if this item matches the target
    if (itemId === targetId || (item.settings?.ref && item.settings.ref === targetId)) {
      return true;
    }
    
    // Recursively check nested children
    if (item.items && isNodeChild(targetId, item.items, visited)) {
      return true;
    }
  }
  
  return false;
};

